import { connect } from 'react-redux';

import EducationCenterView from '../components/Dashboard/EducationCenter/EducationCenterView.jsx';

const EducationCenterContainer = connect()(EducationCenterView);

export default EducationCenterContainer;
